// extracted by mini-css-extract-plugin
export default {"banner":"hL","banner_wrapper":"iL","text":"jL","new_at":"kL","rounded_arrow":"lL","image":"mL","video":"nL"};
    if(module.hot) {
      // 1713996748319
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  